import { useMatch } from 'react-router-dom';
import type { DesignSectionKey } from './DesignSectionKey';
import { isDesignSection } from './designSections';

/**
 * Розділ «Проєктування», відкритий зараз (маршрут /:group/:module/design/:item, ADR-028), інакше undefined. Розділи-списки (усі, крім моделі даних)
 * у прототипі v4 відкривають список модуля бізнес-аналізу від імені модуля: меню модуля тоді коротке, із простою шапкою (група, назва,
 * «N записів»), а не власною шапкою модуля (завдання, база знань).
 */
export function useDesignSection(): DesignSectionKey | undefined {
  const item = useMatch('/:group/:module/design/:item')?.params.item;
  return isDesignSection(item) ? item : undefined;
}
